import { Box, Typography } from "@mui/material";
import { HotkeyBadge } from "./scrapEyeLayoutCommon";

export const EcsItem = ({
  hotkey,
  onClick,
  isSelectable = false,
}: {
  hotkey?: string;
  onClick?: (name: string) => void;
  isSelectable?: boolean;
}) => (
  <Box
    onClick={() => isSelectable && onClick?.("ecs")}
    sx={{
      width: 100,
      height: 275,
      bgcolor: "grey.600",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 1,
      border: 2,
      borderColor: "grey.800",
      cursor: isSelectable && onClick ? "pointer" : "default",
      transition: "all 0.15s ease-in-out",
      "&:hover":
        isSelectable && onClick
          ? {
              transform: "scale(1.05)",
              boxShadow: 4,
              borderColor: "primary.main",
            }
          : {},
    }}
  >
    <Typography variant="h6" sx={{ color: "white", fontWeight: "bold" }}>
      ECS
    </Typography>
    {hotkey ? <HotkeyBadge hotkey={hotkey} /> : null}
  </Box>
);
